import N8nSelectableList from './SelectableList.vue';

export default N8nSelectableList;
